var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticClass:"panel-header",attrs:{"placeholder":"监听状态查询","clearable":""},on:{"change":_vm.selectChange},model:{value:(_vm.botId),callback:function ($$v) {_vm.botId=$$v},expression:"botId"}},_vm._l((_vm.wxList),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.botName,"value":item.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }